import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { HttpStatus } from "../../../common/Constants";
import { STATUS_FJB_OPTIONS } from "../constant";
import { removeNullFields } from "../../../common/mapper";

class FakturJualBengkelDGIFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warnaOptions: [],
      unitTypeOptions: [],
      varianOptions: [],
      filter: {},
    };
  }

  componentDidMount = () => {
    this.loadData();
  };

  loadData = async () => {
    const { setError, onTriggerLoading, submittedFilterData } = this.props;
    if (submittedFilterData) {
      this.setState({
        filter: submittedFilterData,
      });
    }

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
      setError: setError,
      menuName: "Faktur Jual Bengkel - Data Unit",
      args: {},
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        varianOptions: res.data.data.map((d) => {
          return {
            label: `${d.kodeVariant} - ${d.namaVariant}`,
            value: d.kodeVariant,
            namaVariant: d.namaVariant,
          };
        }),
      });
    }
    onTriggerLoading();
  };

  fetchWarna = async (value) => {
    const { onTriggerLoading, setError } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
      setError: setError,
      menuName: "Sales Order - Faktur Jual",
      args: { paramFilters: { kodeVariant: value } },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevState) => ({
        ...prevState,
        warnaOptions: res.data.data.map((item) => ({
          label: item.kodeWarna,
          value: item.kodeWarna,
          namaWarna: item.namaWarnaKomersil,
        })),
      }));
    }
  };

  handleValueChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState({
      filter: {
        status: null,
        kodeCabang: null
      },
    });
  };

  handleSubmit = () => {
    const { onSubmit, onClickClose } = this.props;
    const { filter } = this.state;
    onSubmit(filter);
    onClickClose();
  };

  render() {
    const { onClickClose, visible, cabangOptions } = this.props;
    const { filter, varianOptions, warnaOptions } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Filter Search"
          visible={visible}
          onClickClose={() => onClickClose()}
          content={
            <ModalContainer>
              <FlexView column>
                <SimpleDDL
                  id="select_options_kode_cabang"
                  name="kodeCabang"
                  label="Kode Cabang"
                  box="search"
                  isClearable
                  options={cabangOptions}
                  value={filter.kodeCabang}
                  onChange={(value, { name }) =>
                    this.handleValueChange(name, value)
                  }
                />
                <FlexView column vAlignContent="center">
                  <h4 className="txt-site txt-11 txt-main txt-bold">
                    Tanggal FJB:
                  </h4>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <div style={{ width: "100%" }}>
                      <SimpleDate
                        id={`select_date_startTanggalFjb`}
                        name="startTanggalFJB"
                        nextdate
                        date={filter?.startTanggalFJB}
                        maxDate={filter?.endTanggalFJB}
                        onChange={(value) =>
                          this.handleValueChange(
                            "startTanggalFJB",
                            moment(value)?.format("DD-MM-YYYY")
                          )
                        }
                      />
                    </div>
                    <span className="margin-bottom-20px">To</span>
                    <div style={{ width: "100%" }}>
                      <SimpleDate
                        id={`select_date_endTanggalFjb`}
                        name="endTanggalFJB"
                        nextdate
                        date={filter?.endTanggalFJB}
                        onChange={(value) =>
                          this.handleValueChange(
                            "endTanggalFJB",
                            moment(value)?.format("DD-MM-YYYY")
                          )
                        }
                      />
                    </div>
                  </FlexView>
                </FlexView>
                <SimpleInput
                  id="input_text_no_fjb"
                  name="nomorFJB"
                  label="No FJB"
                  value={filter?.nomorFJB}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_no_polisi"
                  name="nomorPolisi"
                  label="No Polisi"
                  value={filter?.nomorPolisi}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_nama_pemilik"
                  name="namaPemilik"
                  label="Nama Pemilik"
                  value={filter?.namaPemilik}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_nama_pembawa"
                  name="namaPembawa"
                  label="Nama Pembawa"
                  value={filter?.namaPembawa}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_no_mesin"
                  name="nomorMesin"
                  label="No Mesin"
                  value={filter?.nomorMesin}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_no_rangka"
                  name="nomorRangka"
                  label="No Rangka"
                  value={filter?.nomorRangka}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleDDL
                  id="select_options_kode_varian"
                  name="kodeVarian"
                  label="Kode Varian"
                  box="search"
                  isClearable
                  options={varianOptions}
                  value={filter?.kodeVarian ?? null}
                  onChange={(value, { name }) => {
                    console.log(value)
                    this.handleValueChange(name, value);
                    this.handleValueChange("namaVarian", value?.namaVariant);
                    this.fetchWarna(value?.value);
                  }}
                />
                <SimpleInput
                  id="input_text_nama_varian"
                  name="namaVarian"
                  label="Nama Varian"
                  value={filter?.namaVarian}
                  readOnly
                />
                <SimpleDDL
                  id="select_options_kode_warna"
                  name="kodeWarna"
                  label="Kode Warna"
                  box="search"
                  isClearable
                  options={warnaOptions}
                  value={filter?.kodeWarna ?? null}
                  onChange={(value, { name }) => {
                    this.handleValueChange(name, value);
                    this.handleValueChange("namaWarna", value?.namaWarna);
                  }}
                />
                <SimpleInput
                  id="input_text_nama_warna"
                  name="namaWarna"
                  label="Nama Warna"
                  value={filter?.namaWarna}
                  readOnly
                />
                <SimpleDDL
                  id="select_options_status"
                  name="status"
                  label="Status"
                  box="search"
                  isClearable
                  value={filter?.status}
                  options={STATUS_FJB_OPTIONS}
                  onChange={(value, { name }) =>
                    this.handleValueChange(name, value)
                  }
                />
              </FlexView>
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton text="Clear" onClick={this.handleClearFilter} />
                <SimpleButton
                  text="Terapkan"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default FakturJualBengkelDGIFilter;
